import React from 'react';
import { useTranslation } from 'react-i18next';
import chartPaywallDark from '@/assets/images/evaluation/chart-paywall-dark.webp';
import chartPaywall from '@/assets/images/evaluation/chart-paywall.webp';

interface Props {
  description?: string;
}

export const EvaluationChartPaywall: React.FC<Props> = ({ description }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-3 md:py-5 md:pr-5 md:pl-4">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <h4 className="text-title-24 text-foreground">
          {t('diary.evaluation.paywallTitle')}
        </h4>
        <p className="text-body-13 md:text-body-16 text-muted-foreground">
          {description ?? t('diary.evaluation.paywallDescription')}
        </p>
      </div>

      <img
        src={chartPaywall}
        alt=""
        className="h-[100px] w-auto shrink-0 md:h-[160px] md:w-[261px] dark:hidden contrast:hidden"
      />
      <img
        src={chartPaywallDark}
        alt=""
        className="hidden h-[100px] w-auto shrink-0 md:h-[160px] md:w-[261px] dark:block contrast:block"
      />
    </div>
  );
};
